import PropTypes from 'prop-types'
import React from 'react'
import { classes } from '../utils/components'
import styles from './text-block.module.css'

/**
 * @param className
 * @param text - supports both string and html
 */
const TextBlock = ({
  className,
  fontClass = 'text-xl md:text-2xl font-light',
  colorClass = 'text-primary',
  text,
}) => {
  if (text && text.childMarkdownRemark !== null) {
    return text.childMarkdownRemark && text.childMarkdownRemark.html ? (
      <div
        className={classes(styles.textBlock, fontClass, colorClass, className)}
        dangerouslySetInnerHTML={{ __html: text.childMarkdownRemark.html }}
      />
    ) : (
      <div
        className={classes(styles.textBlock, className, fontClass, colorClass)}
      >
        {text}
      </div>
    )
  } else return null
}

TextBlock.propTypes = {
  className: PropTypes.string,
  fontName: PropTypes.string,
  colorClass: PropTypes.string,
  text: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
}

export default TextBlock
